import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { hash, concat } from '@ember/helper'
import UiButtonLinkTo from 'teacher-ui-client/components/ui-button/link-to'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'
import { eq } from 'ember-truth-helpers'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'

interface Signature {
  Element: HTMLDivElement
  Args: {
    subscriptionType: SubscriptionType
    bigBookLevelRange: string[]
  }
}

export const BigBookLevelSelect: TOC<Signature> = <template>
  <div
    data-test-big-book-levels
    class="border-dusty-black-200 rounded-md border px-5 py-4
      {{if (eq (themeKey @subscriptionType) ThemeKeys.blue) 'bg-oceany-blue-100'}}
      {{if (eq (themeKey @subscriptionType) ThemeKeys.green) 'bg-ms-green-100'}}
      {{if (eq (themeKey @subscriptionType) ThemeKeys.darkBlue) 'bg-wl-blue-100'}}"
    ...attributes
  >
    <h3 class="mb-4">
      {{t "bigBooks.bigBooksLevel"}}
    </h3>
    <nav class="flex flex-wrap gap-2">
      <UiButtonLinkTo
        class="min-w-16"
        data-value="all"
        @appearance={{ButtonAppearance.mutedWithActive}}
        @query={{hash bigBookLevel="all"}}
        @route="subscription-type.big-books"
      >{{t "all"}}</UiButtonLinkTo>
      {{#each @bigBookLevelRange as |level|}}
        <UiButtonLinkTo
          class="min-w-16"
          data-value={{level}}
          @appearance={{ButtonAppearance.mutedWithActive}}
          @query={{hash bigBookLevel=level}}
          @route="subscription-type.big-books"
        >{{t (concat "bigBooks.levels." @subscriptionType) level=level}}</UiButtonLinkTo>
      {{/each}}
    </nav>
  </div>
</template>
